import request from "../utils/request";
/**
 * 业务员登陆
 * @param data
 * @returns {ClientRequest}
 */
export function salesmanLogin(data) {
    return request({
        url: '/salesman/login',
        method: 'post',
        data
    })
}
export function orderList(data) {
    return request({
        url: '/salesman/order/list',
        method: 'post',
        data
    })
}
export function createOrder(data) {
    return request({
        url: '/order/create',
        method: 'post',
        data
    })
}
export function checkUserInfo(data) {
    return request({
        url: '/order/check',
        method: 'post',
        data
    })
}
export function codeCountry() {
    return request({
        url: '/code/country',
        method: 'post',
    })
}
export function codeCity (data) {
    return request({
        url: '/code/city',
        method: 'post',
        data
    })
}
export function deleteOrder (data) {
    return request({
        url: '/order/delete/salesman',
        method: 'post',
        data
    })
}
export function queryInstallment(data) {
    return request({
        url: '/report/queryInstallment',
        method: 'post',
        data
    })
}
export function payCreate(data) {
    return request({
        url: '/pay/in',
        method: 'post',
        data: {
            ...data,
            payChannel: 'WAVEPAY'
        }
    })
}
export function paySumbit(data) {
    return request({
        url: '/pay/sumbit',
        method: 'post',
        data
    })
}
export function modifyOrderInfo (data) {
    return request({
        url: '/order/modify',
        method: 'post',
        data
    })
}
export function hubtelCheckMsisdn (msisdn) {
    return request({
        url: '/huttel/preapproval/check/msisdn',
        method: 'post',
        params: { msisdn },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function hubtelInitiate (data) {
    return request({
        url: '/huttel/preapproval/initiate',
        method: 'post',
        data
    })
}
export function hubtelVerify (clientReferenceId, otpCode) {
    return request({
        url: '/huttel/preapproval/verify',
        method: 'post',
        params: { clientReferenceId, otpCode },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function hubtelGetDataById (id) {
    return request({
        url: '/huttel/preapproval/select',
        method: 'post',
        params: { id },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function hubtelCheckStatus (clientReferenceId) {
    return request({
        url: '/huttel/preapproval/check',
        method: 'post',
        params: { clientReferenceId },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function hubtelCancel (clientReferenceId) {
    return request({
        url: '/huttel/preapproval/cancel',
        method: 'post',
        params: { clientReferenceId },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function hubtelReactivate (clientReferenceId) {
    return request({
        url: '/huttel/preapproval/reactivate',
        method: 'post',
        params: { clientReferenceId },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userCheckByMobile (mobile) {
    return request({
        url: '/user/checkByMobile',
        method: 'post',
        params: { mobile },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userCheckByIdNum (idNum) {
    return request({
        url: '/user/checkByIdNum',
        method: 'post',
        params: {idNum},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userCheck(mobile, idNum) {
    return request({
        url: '/user/check',
        method: 'post',
        params: {mobile, idNum},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function storeListAll() {
    return request({
        url: '/store/list/all',
        method: 'post',
    })
}
export function getAllLoanProduct() {
    return request({
        url: '/phone/config/loanProduct/listAll',
        method: 'post',
    })
}
export function configOfModels() {
    return request({
        url: '/phone/config/models',
        method: 'post',
    })
}
export function configOfMemorySize() {
    return request({
        url: '/phone/config/memories',
        method: 'post',
    })
}
export function userLogin (data) {
    return request({
        url: '/customer/login',
        method: 'post',
        data
    })
}
export function userOrderList(mobile) {
    return request({
        url: '/customer/order/list',
        method: 'post',
        params: {mobile},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userOrderDetail(orderNo) {
    return request({
        url: '/customer/order/detail',
        method: 'post',
        params: {orderNo},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userModifyPassword (password, userInfoId) {
    return request({
        url: '/customer/updatePassword',
        method: 'post',
        params: {password, userInfoId},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export function userOpayCreate (orderNo, amount) {
    return request({
        url: '/pay/in',
        method: 'post',
        params: {orderNo, amount},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: {
            amount: amount,
            phoneNumber: orderNo,
            orderNo,
            payChannel: 'OPAY'
        }
    })
}
export function opayCashierCreate (data) {
    return request({
        url: '/pay/in',
        method: 'post',
        data: {
            ...data,
            payChannel: 'OPAY'
        }
    })
}
export function pixelCreate (data) {
    return request({
        url: '/pay/in',
        method: 'post',
        data: {
            ...data,
            payChannel: 'PIXPAY'
        }
    })
}
export function feexPayCreate (data) {
    return request({
        url: '/pay/in',
        method: 'post',
        data: {
            ...data,
            payChannel: 'FEEXPAY'
        }
    })
}
export function azampayMnoCheckout (data) {
    return request({
        url: '/azampay/mno/checkout',
        method: 'post',
        data
    })
}
export function azampayCheckoutStatus (id) {
    return request({
        url: '/azampay/checkout/status',
        method: 'post',
        params: {id},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
